<template>
  <div>

    <h1 style="font-size: 24px; color: black;">任务管理</h1>
    <el-tabs type="card" v-model="selectedActivityType" @tab-click="changeActivityTypeStyle" >
        <el-tab-pane v-for="item in  allActivityTypes"  :name="item.id+'' " :key="item.id" :label="item.name">
        </el-tab-pane>
    </el-tabs>
    <div style="margin-bottom: 10px;">

      <table>
        <tr>
          <td>
            <el-button v-if=" selectedActivityType==='0' || selectedActivityType==='1' || selectedActivityType==='3' " type="primary"
             @click="editDialogFun(true,'新增任务')">新增</el-button>
          </td>
        </tr>
      </table>
    </div>
    <div>
      <span class="my-handle" aria-hidden="true"></span>
    </div>

    <div>
      <h1 style="color:red">1.新增任务的排序默认为最后一个,状态为可用;</h1>
      <h1 style="color:red">2.修改顺序的方式:直接拖拽即可生效,对新用户立即生效;</h1>
      <h1 style="color:red">ps:目前有一种情况就是已有不可用任务的时候将非末尾节点移动到末尾节点会不进行处理 可以通过移动末尾节点来实现操作</h1>
      <el-table border :data="tasks" row-key="id"  :span-method="cellMerge" v-loading="loading">
        <el-table-column v-if="selectedActivityType!=='3'" type="index" width="50" label="序号"></el-table-column>
        <el-table-column   v-else width="50" label="排序" >
          <i class="el-icon-rank my-handle"></i>
        </el-table-column>
        <el-table-column v-if="selectedActivityType==='3'" prop="indexMerge" width="50" label="序号"></el-table-column>
        <el-table-column v-if="selectedActivityType!=='3'" prop="id" label="任务id"></el-table-column>
        <el-table-column v-if="selectedActivityType==='3'" prop="combineName" label="合并任务名称"></el-table-column>
        <el-table-column prop="type" label="类型"  :formatter="typeFormatter"> </el-table-column> 
        <el-table-column v-if="selectedActivityType==='3'" prop="name" label="旧任务名称"></el-table-column>
        <el-table-column v-if="selectedActivityType!=='3'" prop="name" label="任务名称"></el-table-column>
        <el-table-column v-if="selectedActivityType!=='6' && selectedActivityType!=='7'" prop="number" label="达成条件" > </el-table-column>
        <el-table-column v-if="selectedActivityType!=='6' && selectedActivityType!=='7'" prop="rewards" label="奖励信息" :formatter="rewardsFormatter"> </el-table-column> 
         <el-table-column label="开关" align="center" width="150px">
         <template slot-scope="scope">
                    <el-switch v-model="scope.row.isUse"
                               :active-value="true"
                               :inactive-value="false"
                               active-text="开启"
                               inactive-text="关闭"
                               @change="update(scope.row)">
                    </el-switch>
           </template>
        </el-table-column>
        <el-table-column v-if="selectedActivityType==='3'" prop="id" label="任务id"></el-table-column>
         <el-table-column v-if="selectedActivityType!=='6' && selectedActivityType!=='7'"     label="是否第一个任务" >
          <template slot-scope="scope">
            {{ scope.row.isFirst ?  '是': '否' }}
          </template>
        </el-table-column>
        <el-table-column v-if="selectedActivityType!=='6' && selectedActivityType!=='7'"     label="上一个任务编号" >
          <template slot-scope="scope">
            {{ scope.row.pre ?  scope.row.pre: '无' }}
          </template>
        </el-table-column>
        <el-table-column v-if="selectedActivityType!=='6' && selectedActivityType!=='7'"     label="下一个任务编号" >
          <template slot-scope="scope">
            {{ scope.row.next ?  scope.row.next: '无' }}
          </template>
        </el-table-column>
        <el-table-column prop="dtCreate" label="创建时间" :formatter="formatDate"></el-table-column>
        <el-table-column prop="updateDt" label="更新时间" :formatter="formatDate"></el-table-column>
        <el-table-column label="操作"   align="center">
          <template slot-scope="scope">
            <el-button plain   size="mini" type="success" @click="editDialogFun(true,'编辑',scope.row)">编辑</el-button> 
          </template>
        </el-table-column>
      </el-table>
    </div>
 
    <!-- 日常任务编辑弹窗 -->
    <el-dialog :title="editDialog.title" v-if="selectedActivityType=='3'"  :show-close=false :close-on-click-modal=false  
     center :visible.sync="editDialog.show" width="70%" :data="newStyleTasks">
      <el-form>
        <el-form-item  label="合并任务名称："  >  
          <el-input style="width: 220px" type="text" maxlength="20" placeholder="不超过20个字符" v-model="newStyleTasks.name"></el-input> 
        </el-form-item>
        <el-form-item  label="任务类型：">
            <el-select v-model="newStyleTasks.type" filterable placeholder="请选择/输入"  >
              <el-option
                  v-for="item in typeValues"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
 
        <el-card shadow="hover" style="margin-top:10px" v-for="(item1,index1) in newStyleTasks.tasks" v-bind:key="index1" >
          <div slot="header" >
              <div style="height:40px" >
                <el-col :span="6"><h1 >子任务{{index1+1}}</h1></el-col>
                <el-col :span="6" :offset="12" style="margin-top:5px" ><el-button type="danger" @click="removeDailySubTask(index1)" >删除子任务</el-button></el-col>
              </div> 
          </div>
            <el-form-item  label="旧版本任务名称："  >  
              <el-input style="width: 220px" type="text" maxlength="20" placeholder="不超过20个字符" v-model="item1.name"></el-input> 
            </el-form-item>
            <el-form-item label="数量/时长:" :inline="true">
              <el-input-number  :min="1" :max="999" tyle="width: 220px" type="text" v-model="item1.number"> </el-input-number>
              &nbsp;
              <el-select v-if="item1.type===0" v-model="timeUnit"  placeholder="请选择/输入"  >
                        <el-option label="分钟" value="1"></el-option>
                        <el-option label="小时" value="60"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item 
                v-for="(item2, index2) in item1.rewards"
                :label="'奖励' + (index2+1)"
                :key="item2.key"
                :prop="'rewards.' + index2 + '.value'"
              >
              <span>奖品：</span>
              <el-select    v-model="item2.prize.id" filterable placeholder="请选择/输入"  >
                  <el-option
                      v-for="item in packages"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select> 
                <span> 获得数量：</span>
                <el-input-number  :min="1" :max="999"  type="text" v-model="item2.number"> </el-input-number>
                &nbsp;
                <el-button @click.prevent="removeDailySubTaskReward(index1,index2)" type="danger">删除奖励</el-button>
            </el-form-item>
            <el-form-item style="text-align-last: left;">
                <el-button plain size="middle" type="warning" @click="addDailyAward(index1)" >增加奖励条目</el-button>
            </el-form-item>
        </el-card>
        <el-form-item> 
            <el-button style="float: left;"  type="success" @click="addDailySubTask"  >新增子任务条目</el-button>
        </el-form-item>
        <el-form-item style="text-align-last: center;">
          <el-button plain size="middle" type="primary" @click="saveDailyTaskMethod" v-loading.fullscreen.lock="fullscreenLoading">确定</el-button>
          <el-button plain size="middle" type="info" @click="closeDialog()">返回</el-button>
        </el-form-item>
      </el-form> 
    </el-dialog>

    <!-- 非日常任务编辑处理 -->
    <el-dialog :title="editDialog.title" v-if="selectedActivityType=='0' || selectedActivityType=='1' ||  selectedActivityType=='2'||  selectedActivityType=='4' ||  selectedActivityType=='5'"  center :visible.sync="editDialog.show" width="70%" :data="task">
      <el-form>
        <el-form-item  label="任务名称："  >  
          <el-input style="width: 220px" type="text" maxlength="20" placeholder="不超过20个字符" v-model="task.name"></el-input> 
        </el-form-item>
        <el-form-item  label="任务类型：">
            <el-select v-model="task.type" filterable placeholder="请选择/输入"  >
              <el-option
                  v-for="item in typeValues"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="任务数量/时长:">
          <el-input-number  :min="0" :max="999" tyle="width: 220px" type="text" v-model="task.number"> </el-input-number>
          &nbsp;
          <el-select v-if="task.type===0" v-model="timeUnit"  placeholder="请选择/输入"  >
                    <el-option label="分钟" value="1"></el-option>
                    <el-option label="小时" value="60"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item  label="是否可用:">
          <el-switch v-model="task.isUse"
                               :active-value="true"
                               :inactive-value="false"
                               active-text="是"
                               inactive-text="否" >
                    </el-switch>
        </el-form-item> 
        <el-form-item  label="初始任务:"> 
          <el-switch v-model="task.isFirst"
                               :active-value="true"
                               :inactive-value="false"
                               active-text="是"
                               inactive-text="否" >
                    </el-switch>
        </el-form-item>
        <!-- <el-form-item v-if="!task.isFirst"  label="上一级任务："> 
            <el-select v-model="task.pre" filterable placeholder="请选择/输入"  >
              <el-option
                  v-for="item in tasks"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
        </el-form-item> -->
        <el-form-item 
            v-for="(domain, index) in task.rewards"
            :label="'奖励' + (index+1)"
            :key="domain.key"
            :prop="'rewards.' + index + '.value'"
          >
          <span>奖品：</span>
          <el-select    v-model="domain.prize.id" filterable placeholder="请选择/输入"  >
              <el-option
                  v-for="item in packages"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select> 
            <span> 获得数量：</span>
            <el-input-number   :min="0" :max="999"  type="text" v-model="domain.number"> </el-input-number>
            &nbsp;
            <el-button @click.prevent="removeAward(domain)" type="danger">删除</el-button>
        </el-form-item>
        
        <el-form-item style="text-align-last: center;">
            <!-- 这里写死type不等于1的时候才显示增加奖励条目按钮 -->
            <el-button plain size="middle" v-if="this.selectedActivityType!=='1'" type="warning" @click="addAward" >增加奖励条目</el-button>
            <el-button plain size="middle" type="success" @click="saveOrUpdatePrize">确定</el-button>
            <el-button plain size="middle" type="info" @click="closeDialog()">返回</el-button>
          <!-- </td> -->
        </el-form-item>
      </el-form>

    </el-dialog>
<!-- 宝箱 红包 任务编辑处理 -->
    <el-dialog :title="editDialog.title" v-if="selectedActivityType=='6' || selectedActivityType=='7'"  center :visible.sync="editDialog.show" width="70%" :data="task">
      <el-form>
        <el-form-item  label="任务名称："  >  
          <el-input style="width: 220px" disabled type="text" maxlength="20" placeholder="不超过20个字符" v-model="task.name"></el-input> 
        </el-form-item>
        <el-form-item  label="任务类型：">
            <el-select v-model="task.type" disabled filterable placeholder="请选择/输入"  >
              <el-option
                  v-for="item in typeValues"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item  label="是否可用:">
          <el-switch disabled v-model="task.isUse"
                               :active-value="true"
                               :inactive-value="false"
                               active-text="是"
                               inactive-text="否" >
                    </el-switch>
        </el-form-item> 
        <el-form-item  label="初始任务:"> 
          <el-switch disabled v-model="task.isFirst"
                               :active-value="true"
                               :inactive-value="false"
                               active-text="是"
                               inactive-text="否" >
                    </el-switch>
        </el-form-item>
        <el-divider content-position="left">以上不可编辑 以下可编辑</el-divider>
        <el-form-item v-if="selectedActivityType=='7'"  label="每人红包上限:">
          <el-input-number  :min="0" :max="999" tyle="width: 220px" type="text" v-model="task.amount"  > </el-input-number>
        </el-form-item>
        <el-form-item v-if="selectedActivityType=='7'"  label="红包条目数量:">
          <el-input-number  :min="0" :max="999" tyle="width: 220px" type="text" v-model="tempRewardsNumber" @change="batchAddTempRewards(task)" > </el-input-number>
        </el-form-item>
        <el-form-item 
            v-for="(domain, index) in task.rewards"
            :label="'奖励' + (index+1)"
            :key="domain.key"
            :prop="'rewards.' + index + '.value'"
          >
          <span>奖品：</span>
          <el-select    v-model="domain.prize.id" filterable placeholder="请选择/输入"  >
              <el-option
                  v-for="item in packages"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select> 
            <span v-if="selectedActivityType=='6'"> 获得数量：</span>
            <el-input-number v-if="selectedActivityType=='6'"   :min="1" :max="999"  type="text" v-model="domain.number"> </el-input-number>
            &nbsp;
            <el-button @click.prevent="removeAward(domain)" type="danger">删除</el-button>
        </el-form-item>
        
        <el-form-item style="text-align-last: center;">
            <!-- 这里写死type不等于1的时候才显示增加奖励条目按钮 -->
            <el-button plain size="middle" v-if="this.selectedActivityType!=='7'" type="warning" @click="addAward" >增加奖励条目</el-button>
            <el-button plain size="middle" type="success" @click="saveOrUpdatePrize">确定</el-button>
            <el-button plain size="middle" type="info" @click="closeDialog()">返回</el-button>
          <!-- </td> -->
        </el-form-item>
      </el-form>

    </el-dialog>
    <!-- 消息弹窗 不确定是否可以删除-->
    <el-dialog :title="messageDialog.title" center :visible.sync="messageDialog.show" width="30%">
      <h1 v-html="messageDialog.message"/>
      <el-button plain size="mini" type="success" @click="messageDialogFun(false)">确定</el-button>
    </el-dialog>

  </div>

</template>

<script>
import Sortable from 'sortablejs';
import utils from '@/utils'
import {  
   typeTaskInfo,allEnablePacketList, allTaskList,changeStateTask,addTask,editTask,allActivityTypeInfo,changeTaskOrder,saveDailyTask,changeDailyTaskOrder,batchChangeTask} from "@/http/api";
import store from '@/store';
export default {
  inject: ['reload'],
  name: "TaskConfig",
  data() {
    return {
      loading: false,
      editDialog: {
        show: false,
        title: null
      },
      typeValues: [ ], 
      task: {
        id: null,
        type: null,
        name: null,
        number:null,
        pre: null,
        next: null,
        isUse:null,
        isFirst:null,
        rewards:[],
        activityType:null,
        amount:0
      }, 
      tasks: [],
      newStyleTasks:{
        name:null,
        type:null,
        tasks:[],
        preId:null,
        nextId:null
      },
      packages: null,
      timeUnit: "1",
      //编辑标志位
      editFlag : false, 
      headers: {},
      messageDialog: {
        show: false,
        title: null,
        message: null
      },
      //全部可选活动type
      allActivityTypes:[],
      //当前选中活动type类型
      selectedActivityType: store.state.taskConst.selectedActivityType.toString(),
      //合并行数数组
      spanArr:[],
      //临时保存前一位的索引信息
      pos:null,
      // 排序后的type与index映射List
      indexTypeList:[],
      //order TypeList
      orderTypeList:[],
      //类型是否可用
      orderTypeIsUseList:[],
      //记录当前类型的头结点
      preNodeList:[],
      //记录当前类型的尾结点
      nextNodeList:[],
      fullscreenLoading: false,
      tempRewardsNumber: null,
    }
  },
  methods: {
      drag() {
            const el = document.querySelectorAll(
              ".el-table__body-wrapper > table > tbody"
            )[0];
            // console.log(el)
            Sortable.create(el, {
              disabled: false, // 拖拽不可用? false 启用
              ghostClass: 'sortable-ghost', //拖拽样式
              animation: 150, // 拖拽延时，效果更好看
              // filter:".not-draggable",
              // draggable:".draggable-flag",
              handel:".my-handle",
              onEnd: (e) => { // 拖拽结束时的触发
                  let arr = this.tasks; // 获取表数据
                  //获取newIndex pre 和next 节点信息
                  // console.log("===================")
                  
                  // console.log(e.oldIndex)
                  // console.log(e.newIndex)
                  // console.log("===================")
                  if(arr[e.oldIndex].isUse==false){
                    // 报警
                    this.$message.error('不可用节点不可调整位置即将刷新页面！');
                    this.reload(); 
                    return;
                  }else{
                   
                     if(this.selectedActivityType=='3'){
                        //1.校验
                        console.log("日常任务排序")
                       let batchTasksOrderData={
                            type:arr[e.oldIndex].type,
                            beforePre:null,
                            beforeNext:null,
                            afterPre:null,
                            afterNext:null
                          }
                          // arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
                          // this.$nextTick(function () {
                          //   this.tasks= arr;
                          // })
                          //索引与type的映射数组 indexTypeList
                          //type的list数组 orderTypeList
                          //type对应的是否可用 orderTypeIsUseList
                          //默认移动到newType之前的位置
                          var oldType=this.indexTypeList[e.oldIndex];
                          var newType= this.indexTypeList[e.newIndex];
                          //移动前后type类型相同
                          if(oldType==newType){
                            console.log("not change")
                            return;
                          }
                          //设置移动前参数信息 beforePre beforeAfter
                          var oldTypeIndex= this.orderTypeList.indexOf(oldType);
                          batchTasksOrderData.beforePre=this.preNodeList[oldTypeIndex];
                          batchTasksOrderData.beforeNext=this.nextNodeList[oldTypeIndex];
                          // 判断新位置的type
                          var nextTypeIndex= this.orderTypeList.indexOf(newType);
                          if(oldTypeIndex==nextTypeIndex-1){
                            console.log("same Index not change")
                            return;
                          }
                          if(!this.orderTypeIsUseList[nextTypeIndex]){
                            // 新位置的节点不可用
                            console.log("change to last")
                            //当前type不可用 默认移动到尾结点位置
                            //查找末尾可用type类型
                            // var preType=-1;
                            // console.log("orderTypeIsUseList %o ",this.orderTypeIsUseList)
                            // console.log("orderTypeList %o ",this.orderTypeList)
                            batchTasksOrderData.afterNext=null;
                            //查找末尾可用节点id
                            for(var i = arr.length-1;i>=0;i--){
                              if(arr[i].isUse){
                                if(arr[i].type==oldType){
                                  //说明只有一个节点移动直接返回即可
                                  console.log("not change")
                                  return;
                                }else{
                                  batchTasksOrderData.afterPre=arr[i].id;
                                  break;
                                }
                              }
                            }
                            // for(var i = this.orderTypeIsUseList.length-1;i>=0;i--){
                            //   if(this.orderTypeIsUseList[i]){
                            //     preType=this.orderTypeList[i];
                            //     //

                            //     //
                            //     break;
                            //   }
                            // }
                            // if(preType==-1){
                            //   //2.1说明没找到可用type作为末尾节点 设置pre next 都为null
                            //   batchTasksOrderData.pre=null;
                            //   batchTasksOrderData.next=null;
                            // }else{
                            //    batchTasksOrderData.pre=preType;
                            //    batchTasksOrderData.next=null;
                            // }
                            console.log(batchTasksOrderData);
                            //3请求排序接口
                              changeDailyTaskOrder(batchTasksOrderData).then(resp => {
                              console.log("日常任务排序返回值 %o",resp.data)
                                if (resp.data.status === 0) {
                                  this.$message.success('修改成功');
                                  // this.reload();  
                                }else{
                                  this.$message.error('修改失败即将刷新页面！');
                                  // this.reload(); 
                                }
                              })
                          }else{
                            //2新节点可用情况处理 默认将当前type作为nextType类型
                            if(nextTypeIndex==0){
                              console.log("change to first")
                              //设置头结点
                              batchTasksOrderData.afterPre=null;
                              batchTasksOrderData.afterNext=arr[0].id;
                            }else{
                              console.log("normal change")
                              batchTasksOrderData.afterPre=this.preNodeList[nextTypeIndex];
                                for(var i2 = 0;i2<arr.length;i2++){
                                    if(arr[i2].type==newType){
                                        batchTasksOrderData.afterNext=arr[i2].id;
                                        break;
                                    }
                                }
                            }
                            this.loading=true;
                              setTimeout(()=>{
                                  this.loading=false;
                                  this.reload()
                              },2000);
                            //3请求排序接口
                              console.log(batchTasksOrderData);
                              changeDailyTaskOrder(batchTasksOrderData).then(resp => {
                              console.log("日常任务排序返回值 %o",resp.data)
                                if (resp.data.status === 0) {
                                  this.$message.success('修改成功');
                                  // setTimeout(
                                  //   this.reload()
                                  // ,"1000");
                                }else{
                                  this.$message.error('修改失败即将刷新页面！');
                                    // setTimeout(
                                    //   this.reload()
                                    // ,"1000");
                                }
                              })
                          }
                     }else{
                          // console.log(2)
                          let updateDate={
                            id:arr[e.oldIndex].id,
                            pre:null,
                            next:null
                          }
                          arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
                          this.$nextTick(function () {
                            this.tasks= arr;
                          })
                          if(arr[e.newIndex-1]!=undefined && arr[e.newIndex-1]!=null){
                            //判断前后新节点是否有不可用节点
                            if(!arr[e.newIndex-1].isUse){
                              console.log("not useful")
                              return;
                            }
                              updateDate.pre=arr[e.newIndex-1].id;
                          }
                          if(arr[e.newIndex+1]!=undefined && arr[e.newIndex+1]!=null){
                            if(arr[e.newIndex+1].isUse){
                                updateDate.next=arr[e.newIndex+1].id;
                            }else{
                              //判断前后新节点是否有不可用节点
                              console.log("not useful")
                              return;
                            }
                          }
                          //没修改情况 就是指拖动条但是原地不动也会触发end操作
                          if(arr[e.newIndex].pre==updateDate.pre && arr[e.newIndex].next==updateDate.next){
                            console.log("not change")
                            return;
                          }
                          // console.log(updateDate)
                          // this.$message.warning('将在5秒后更新排序,期间可以撤销操作');
                          //更新顺序 如果异常则刷新页面
                          // setTimeout(
                            changeTaskOrder(updateDate).then(resp => {
                            console.log(3)
                              if (resp.data.status === 0) {
                                // console.log(3.1)
                                this.$message.success('修改成功');
                                this.reload();  
                              }else{
                                // console.log(3.2)
                                this.$message.error('修改失败即将刷新页面！');
                                this.reload(); 
                              }
                            })
                            // ,"5000");
                          // changeTaskOrder(updateDate).then(resp => {
                          //   console.log(3)
                          //     if (resp.data.status === 0) {
                          //       console.log(3.1)
                          //       this.$message.success('修改成功');
                          //       this.reload();  
                          //     }else{
                          //       console.log(3.2)
                          //       this.$message.error('修改失败即将刷新页面！');
                          //       this.reload(); 
                          //     }
                          //   })
                     }



                   
                  }
              },
            });
          },
    formatDate: function(row, column, cellValue) {
                return utils.DateUtil.formatDate(cellValue, "yyyy-MM-DD HH:mm:ss")
     },
    typeFormatter: function (row, column, cellValue){
      var temp="其他"
      this.typeValues.forEach( item => {
        if(item.id===cellValue){
               temp=item.name;
            } 
      })
      return temp
    },
    rewardsFormatter: function (row, column, cellValue){
      var temp=""
      // console.log(cellValue.length)
      if(cellValue!==null && cellValue.length>0){
         cellValue.forEach( item => {
          temp+="|"+item.prize.name+"*"+item.number
        })
      } 
      return temp
    },
     // 合并单元格
     cellMerge({row,rowIndex,columnIndex}){
      //  console.log(row)
      //  console.log("row=%d column=%d rowIndex=%d columnIndex=%d",row,column,rowIndex,columnIndex)
      if(row.activityType==3){
        if( columnIndex ===1 || columnIndex ===2 || columnIndex ===3 || columnIndex ===7 || columnIndex ===14){
          //  console.log(row)
          const _row=this.spanArr[rowIndex];
          const _col=_row>0?1:0;
          return {
            rowspan:_row,
            colspan:_col
          }
        }
      }

     },
     // 合并单元格
     batchAddTempRewards(data){
      //  console.log(data)
      //  console.log(Date.now()+Math.round(Math.random()*10))
      //  console.log("row=%d column=%d rowIndex=%d columnIndex=%d",row,column,rowIndex,columnIndex)
      if(data.activityType==7){
        if(data.rewards.length>=this.tempRewardsNumber){
          data.rewards=data.rewards.slice(0,this.tempRewardsNumber);
        }else{
          // console.log(data.amount)
          var lengthTemp=data.rewards.length;
            for (var i=0;i<this.tempRewardsNumber-lengthTemp;i++){
              // console.log(i)
                data.rewards.push({
                      number: 1,
                      prize:{
                        id: null
                      },
                      rank:999,
                      key: Date.now()
                    });

            }
        }


      }

     },
     allTasks(){
        allTaskList(this.selectedActivityType).then(resp=>{
        //  console.log(resp.data.info)
        this.tasks=resp.data.info 
        this.spanArr=[];
        this.pos=null;
        // console.log(this.selectedActivityType==='3')
        //处理合并单元格
        if(this.selectedActivityType==='3'){
          //只处理日常任务

          //设置之后的index序号
          let indexMerge=1;
          let indexTypeListTemp=[];
          let orderTypeListTemp=[];
          let orderTypeIsUseListTemp=[];
          let preNodeListTemp=[];
          let nextNodeListTemp=[];
          for(var i = 0 ; i<this.tasks.length;i++){
            indexTypeListTemp.push(this.tasks[i].type);
            if(i===0){
              this.spanArr.push(1);
              this.pos=0;
              this.$set(this.tasks[0],'indexMerge',indexMerge)
              orderTypeListTemp.push(this.tasks[0].type)
              orderTypeIsUseListTemp.push(this.tasks[0].isUse)
              preNodeListTemp.push(null)
            }else{
              if(this.tasks[i].type===this.tasks[i-1].type){
                this.spanArr[this.pos]+=1;
                this.spanArr.push(0);
              }else{
                indexMerge+=1;
                this.$set(this.tasks[i],'indexMerge',indexMerge)
                this.spanArr.push(1);
                this.pos=i;
                orderTypeListTemp.push(this.tasks[i].type)
                orderTypeIsUseListTemp.push(this.tasks[i].isUse)
                preNodeListTemp.push(this.tasks[i-1].id)
                //这里设置的next节点信息为上一个type类型的next节点信息  最后需要补充一下next信息为null
                nextNodeListTemp.push(this.tasks[i].id)
              }
            }
          }
          nextNodeListTemp.push(null)
          this.indexTypeList=indexTypeListTemp;
          this.orderTypeList=orderTypeListTemp;
          this.orderTypeIsUseList=orderTypeIsUseListTemp;
          this.preNodeList=preNodeListTemp;
          this.nextNodeList=nextNodeListTemp;
          // console.log("preNodeList   %o   ",preNodeListTemp)
          // console.log("nextNodeList   %o   ",nextNodeListTemp)
        }
        // console.log(this.spanArr);
            });
     },
     allPackages(){
        allEnablePacketList().then(resp=>{
        //  console.log(resp.data.info)
        this.packages=resp.data.info
            });
     },
    saveOrUpdatePrize() {
      if (this.task.name == null) {
        this.$message.error('任务名称不能为空！');
        return;
      }
      if (this.task.type == null) {
        this.$message.error('任务类型不能为空！');
        return;
      }
      if (this.task.number == null) {
        this.$message.error('任务时长/数量不能为空！');
        return;
      }

      // if (this.task.isFirst == false) {
      //   if(this.task.pre==null){
      //       this.$message.error('上级任务不能为空！');
      //       return;
      //   }
      // }
      if(this.task.type===0){
        this.task.number=this.task.number*this.timeUnit
        // console.log(this.task.number)
      }
      if(this.editFlag){
        // console.log(this.task)
        if(this.task.activityType==6 || this.task.activityType==7){
          //循环赋值rank
          this.task.rewards.forEach((item, index) => { 
                        item.rank=index+1;
                    })
        }
        // console.log(this.task) 
        // let _this=this;
        editTask(this.task).then(resp => {
        if (resp.data.status === 0) {
              // _this.editDialogFun(false);  
              this.closeDialog();
              this.$message.success('修改成功');
              this.loading=true; 
              //等待加载
                setTimeout(()=>{
                    this.loading=false;
                    this.reload()
                },1000); 
        }else{
          this.$message.error('修改失败');
        }
      });
      }else{
          addTask(this.task).then(resp => {
        if (resp.data.status === 0) {
          this.closeDialog();
          this.$message.success('新增成功');
          this.reload();  
        }else{
          this.$message.error('新增失败');
        }
      });
      }  
    }, 
   update(row){
     //判断是否为日常任务如果是日常任务走另一个接口传入type类型
     if(this.selectedActivityType=='3'){
       var typeIndex=this.orderTypeList.indexOf(row.type);
       var changeData={
         type: row.type,
         isUse: row.isUse,
         preId: this.preNodeList[typeIndex],
         nextId: this.nextNodeList[typeIndex]
       }
          this.loading=true;
          setTimeout(()=>{
              this.loading=false;
              this.reload()
          },2000);
       //日常任务
       batchChangeTask(changeData).then(resp=>{
          if (resp.data.status == 0) {
            // console.log(3.1)
            this.$message.success('修改成功');
            // this.reload();  
          }else{
            this.$message.error('修改失败');
          }
          // else{
          //   //无法修改该属性 设置为相反值不进行 效果就是开关无法修改
          //   row.isUse=!row.isUse;
          // }
      });
     }else{
      // 修改开关更新方法 只需要传入id即可进行转换  ------------------------------------------
      changeStateTask(row.id,row.isUse).then(resp=>{
          if (resp.data.msg==='成功'){ 
                  this.reload();  
          }else{
            //无法修改该属性 设置为相反值不进行 效果就是开关无法修改
            row.isUse=!row.isUse;
          }
      });
     }

  },
    editDialogFun(show, title, data) {
      this.editDialog.show = show;
      this.editDialog.title = title;
 
      this.editFlag=false;
      this.task.id=null,
      this.task.type= null,
      this.task.name= null,
      this.task.number=null,
      this.task.pre= null,
      this.task.next= null, 
      this.task.isUse=false,
      this.task.isFirst=false,
      this.task.rewards=[];
      this.task.amount=0;
      // 初始化编辑 新增 页面数据
        this.newStyleTasks={
          name:null,
          type:null,
          tasks:[],
          preId:null,
          nextId:null
        };
        //这里需要找到最后一个可用的pre id和nextid 给新增准备
            // for(var ii = this.tasks.length-1;ii>=0;ii--){
            //   if(this.tasks[ii].isUse){
            //     this.newStyleTasks.preId=this.preNodeList[ii];
            //     break;
            //   }
            // }
        // console.log(this.newStyleTasks)
      //设置活动类别后台设置即可
      this.task.activityType=this.selectedActivityType;
      //使用临时数组作为修改奖励条目数组  并用深拷贝 不会对原有表单数据进行修改    其他类似地方需要排查
      var tempRewards=JSON.parse(JSON.stringify(data.rewards))
      if(this.selectedActivityType=='3'){
        if (show && data) { 
          // console.log(show)
          // console.log(data)
          //设置子任务
          var tempTasks=[];
          for(var i=0;i<this.tasks.length;i++){
            // console.log(i)
            if(this.tasks[i].type==data.type){
              tempTasks.push(JSON.parse(JSON.stringify(this.tasks[i])))
            }
          }
          this.newStyleTasks.tasks=tempTasks;
          this.newStyleTasks.name=data.combineName;
          this.newStyleTasks.type=data.type;
          var typeIndex=this.orderTypeList.indexOf(data.type);
          this.newStyleTasks.preId=this.preNodeList[typeIndex];
          this.newStyleTasks.nextId=this.nextNodeList[typeIndex];
          //设置编辑标志位
          this.editFlag=true;
        }
      }else if(this.selectedActivityType=='7'){
        if (show && data) { 
        this.task.id=data.id;
        this.task.type= data.type;
        this.task.name= data.name,
        this.task.number= data.number;
        this.task.pre=data.pre;
        this.task.next= data.next;
        this.task.isUse=data.isUse;
        this.task.isFirst=data.isFirst; 
        //设置奖励
        this.task.rewards=tempRewards;
        this.task.amount=data.amount;
          //设置编辑标志位
          this.editFlag=true;
        this.tempRewardsNumber=data.rewards.length
        }
      } else{
          if (show && data) { 
          this.task.id=data.id;
          this.task.type= data.type;
          this.task.name= data.name,
          this.task.number= data.number;
          this.task.pre=data.pre;
          this.task.next= data.next;
          this.task.isUse=data.isUse;
          this.task.isFirst=data.isFirst; 
          //设置奖励
          this.task.rewards=tempRewards;
            //设置编辑标志位
            this.editFlag=true;
          }
      }


    },
    closeDialog(){
      this.editDialog.show = false; 
      this.editFlag=false;
      this.task.id=null,
      this.task.type= null,
      this.task.name= null,
      this.task.number=null,
      this.task.pre= null,
      this.task.next= null, 
      this.task.isUse=false,
      this.task.isFirst=false,
      this.task.rewards=[];
      this.task.amount=0;
      this.tempRewardsNumber=null;
    },
    addAward() {
      this.task.rewards.push({
          number: 0,
          prize:{
            id: null
          },
          rank:999,
          key: Date.now()
        });
    },
    removeAward(item) {
        var index = this.task.rewards.indexOf(item)
        if (index !== -1) {
          this.task.rewards.splice(index, 1)
          this.tempRewardsNumber=this.task.rewards.length;
        }
      },
    messageDialogFun(show, title, message) {
      this.messageDialog.show = show;
      this.messageDialog.title = title;
      this.messageDialog.message = message;
    }, 
    changeActivityTypeStyle(tab ) {
      this.$store.commit('changeSelectedActivityType', tab.name); 
      this.selectedActivityType=tab.name
      this.reload();
      //刷新任务数据
      // this.allTasks();
    }, 
// 日常任务优化相关方法
      // 直接删除子任务方法
        removeDailySubTask(index) {
        if (index !== -1) {
          this.newStyleTasks.tasks.splice(index, 1)
        }
      },
      // 直接删除子任务奖励方法
        removeDailySubTaskReward(index1,index2) {
          this.newStyleTasks.tasks[index1].rewards.splice(index2, 1)
      },
      //新增子任务奖励方法
      addDailyAward(index) {
      if (this.newStyleTasks.tasks[index].rewards.length==3){
        this.$message.warning('不允许添加'); 
        return;
      }
      this.newStyleTasks.tasks[index].rewards.push({
          number: 1,
          prize:{
            id: null
          },
          rank:999
        });
    },
      //新增子任务方法  todo 待优化
      addDailySubTask() {
      this.newStyleTasks.tasks.push({
          name:  null,
          type: this.newStyleTasks.type,
          number:1,
          rewards:[]
        });
    },
    // 保存子任务方法
    saveDailyTaskMethod(){

      
      //校验日常任务奖励条目数是否为3
      if(this.newStyleTasks.tasks.length>0){
        for(var i =0;i<this.newStyleTasks.tasks.length;i++){
          // console.log(this.newStyleTasks.tasks[i].rewards.length)
          if(this.newStyleTasks.tasks[i].rewards.length!=3){
            this.$message.error('存在子任务奖励条目数不为3，请检查奖励信息');
            return; 
          }
        }
      } 
      this.fullscreenLoading=true;
      setTimeout(()=>{
          this.fullscreenLoading=false;
          this.reload()
      },2000);
      //批量新增日常任务接口
      saveDailyTask(this.newStyleTasks).then(resp => {
        if (resp.data.status === 0) {
          this.closeDialog();
          this.$message.success('操作成功');
          
              // setTimeout(()=>{
              //     this.fullscreenLoading=false;
              //     this.reload()
              // },2000);
        }else{
          this.$message.error('操作失败');
        }
      });
      
    },
    // 批量调整日常任务位置
      changeGroupOrder(data){
        //校验参数todo
        changeDailyTaskOrder(data)
      }
  },
  created() {
    //获取全部任务list
     this.allTasks();
     //获取全部奖品信息
     this.allPackages();
     typeTaskInfo().then(resp => {
       this.typeValues=resp.data.info
     });
     //获取全部活动类型
     allActivityTypeInfo().then(resp => {
       this.allActivityTypes=resp.data.info
     })
     this.$nextTick(() => {
      this.drag();
    });
  },
  mounted() {
    this.VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
    this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
  }
}
</script>

<style lang="less">
.sub {
  position: relative;
  left: 570px
}


.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar1 {
  width: 150px;
  height: 200px;
  display: block;
}

.elalert {
  max-width: 89%;
  left: 11%;
}

.iconSize {
  font-size: 14px;
  font-weight: normal;
}

.my-handle {
	cursor: move;
	cursor: -webkit-grabbing;
}

.sortable-ghost {
  background-color: rgb(255, 123, 0) !important;
}
</style>
